/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import React from 'react';

import css from './css.module.less';

//import { Input } from 'src/components/Antd';

import { ModuleCart as _ModuleCart } from '@/src/constrains';

// import { EnumStatus, EnumProductType } from 'src/types/common/product';

//import { productsInit } from '@/src/request/product/product'; //暂时link

const ModuleCart = (props) => {
  //const _d = useDispatch();

  // const fetchData = () => {};

  return (
    <div className={css.moduleCart}>
      <_ModuleCart moduleList={props.moduleList} />
    </div>
  );
};

export default ModuleCart;
